export default __webpack_public_path__ + "static/jedwards-3812baec00d5710ca752eae2791c6919.png";